import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { api, INTENT_COLORS, fmtUsd, fmtTimeAgo } from "@/lib/nexus";
import { ArrowRight } from "lucide-react";

export default function LiveFeed({ limit = 22 }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = () =>
      api.get(`/feed/live?limit=${limit}`).then((r) => setItems(r.data.items));
    load();
    const t = setInterval(() => {
      // Rotate the feed – shift index to simulate stream
      setItems((prev) => {
        if (!prev.length) return prev;
        const [head, ...rest] = prev;
        const shifted = [...rest, { ...head, id: `${head.id}-r${Date.now()}` }];
        return shifted;
      });
    }, 2600);
    return () => clearInterval(t);
  }, [limit]);

  return (
    <div className="panel h-full flex flex-col brackets">
      <span className="b1" /><span className="b2" />
      <div className="px-3 py-2 border-b border-nexus-border flex justify-between items-center">
        <div className="panel-title"><span className="dot" />Live A2A Commerce Feed</div>
        <span className="text-[10px] font-mono text-nexus-cyan animate-flicker">STREAMING</span>
      </div>
      <div className="flex-1 overflow-hidden">
        <AnimatePresence initial={false}>
          {items.slice(0, limit).map((t) => (
            <motion.div
              key={t.id}
              layout
              initial={{ opacity: 0, y: -8, backgroundColor: "rgba(0,240,255,0.12)" }}
              animate={{ opacity: 1, y: 0, backgroundColor: "rgba(0,0,0,0)" }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.35 }}
              className="px-3 py-2 border-b border-nexus-border/60 hover:bg-nexus-panel-2/60"
              data-testid={`feed-item-${t.id}`}
            >
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-1.5 min-w-0">
                  <span className="text-[11px] font-rajdhani font-semibold uppercase tracking-wider truncate">{t.from_name}</span>
                  <ArrowRight size={11} className="text-nexus-text-3 shrink-0" />
                  <span className="text-[11px] font-rajdhani font-semibold uppercase tracking-wider truncate">{t.to_name}</span>
                </div>
                <span className="text-[11px] font-mono text-nexus-text-2 shrink-0">{fmtTimeAgo(t.timestamp)}</span>
              </div>
              <div className="flex items-center justify-between mt-1">
                <span
                  className="text-[9px] font-mono uppercase tracking-widest border px-1.5 py-0.5"
                  style={{ borderColor: INTENT_COLORS[t.intent], color: INTENT_COLORS[t.intent] }}
                >
                  {t.intent_label}
                </span>
                <span className="text-[12px] font-mono text-nexus-text">{fmtUsd(t.value_usd)}</span>
              </div>
              <div className="hash mt-1 truncate">{t.short_hash} · {t.chain}</div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}
